import { ActivityLogsData } from 'store/reducers/activity-log/get-activity-logs/types';

export const GET_GUEST_ACTIVITY_LOGS_REQUEST = 'GET_GUEST_ACTIVITY_LOGS_REQUEST';
export const GET_GUEST_ACTIVITY_LOGS_SUCCESS = 'GET_GUEST_ACTIVITY_LOGS_SUCCESS';
export const GET_GUEST_ACTIVITY_LOGS_FAILURE = 'GET_GUEST_ACTIVITY_LOGS_FAILURE';

interface GetGuestActivityLogsRequest {
  type: typeof GET_GUEST_ACTIVITY_LOGS_REQUEST;
}

interface GetGuestActivityLogsSuccess {
  type: typeof GET_GUEST_ACTIVITY_LOGS_SUCCESS;
  contents: ActivityLogsData;
}

interface GetGuestActivityLogsFailure {
  type: typeof GET_GUEST_ACTIVITY_LOGS_FAILURE;
}

export type GetGuestActivityLogsActionTypes = GetGuestActivityLogsRequest | GetGuestActivityLogsSuccess | GetGuestActivityLogsFailure;
